var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#120732;}.cls-3{fill:#1d1d1b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 310.26,
    y1: 1049.45,
    x2: 1616.11,
    y2: 1049.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00fff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e53ce5"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 999.77,
    cy: 1006.74,
    r: 885.26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1265.89,688.86c76.81-14.36,127.44-88.27,113.08-165.08-14.36-76.81-88.27-127.44-165.08-113.08-76.81,14.36-127.44,88.27-113.08,165.08,14.36,76.81,88.27,127.44,165.08,113.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1616.11 745.5 310.26 742.73 791.36 865.19 474.51 1690.63 1009.84 882.3 1616.11 745.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "942.24 1530.47 1173.62 1530.47 1310 896.93 1071.92 953.36 942.24 1530.47"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1265.89,688.86c76.81-14.36,127.44-88.27,113.08-165.08-14.36-76.81-88.27-127.44-165.08-113.08-76.81,14.36-127.44,88.27-113.08,165.08,14.36,76.81,88.27,127.44,165.08,113.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1616.11 745.5 310.26 742.73 791.36 865.19 474.51 1690.63 1009.84 882.3 1616.11 745.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "942.24 1530.47 1173.62 1530.47 1310 896.93 1071.92 953.36 942.24 1530.47"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1265.89,688.86c76.81-14.36,127.44-88.27,113.08-165.08-14.36-76.81-88.27-127.44-165.08-113.08-76.81,14.36-127.44,88.27-113.08,165.08,14.36,76.81,88.27,127.44,165.08,113.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1616.11 745.5 310.26 742.73 791.36 865.19 474.51 1690.63 1009.84 882.3 1616.11 745.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "942.24 1530.47 1173.62 1530.47 1310 896.93 1071.92 953.36 942.24 1530.47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotn);
export default __webpack_public_path__ + "static/media/MOTN.c4fad113c159c8771f791dfa2caeba3b.svg";
export { ForwardRef as ReactComponent };